
import React, { useCallback, useEffect, useState } from 'react';
import { Input, Popup, Toast } from "antd-mobile"
import { useNavigate } from 'react-router-dom';
import API_ROUTES from '../../api';
import axios from 'axios';
import Icon from '../../icon';
import GetSinglePersonFire from './getSInglePersonFire';
import { useAuth } from '../../app/providers/AuthProvider';
import { LEAVE_REASONS } from '../../features/match/model/leaveReasons';
import './positionDialog.css';
import './signupEditSheet.css';

const UserList = ({ gameDetail, runFunction, memberList }) => {

    const navigate = useNavigate();
    const { memberInfo } = useAuth();
    const refereeListInfo = memberList?.length > 0 ?
        memberList?.filter(item => item.gameType === 1 || item.gameType === 2) : []
    const display = memberList?.find(item => item.id === memberInfo?.id)?.gameType < 5
    // 管理员和当场裁判共享阵容调整权限，统一处理空登录态。
    const canManageRoster = memberInfo?.admin === 1
        || refereeListInfo.some(referee => referee.id === memberInfo?.id)

    const [displayList, setDisplayList] = useState([]);
    const [editingUser, setEditingUser] = useState(null);
    const [selectedPosition, setSelectedPosition] = useState(null);
    const [positionSaving, setPositionSaving] = useState(false);
    const [positionStage, setPositionStage] = useState('position');
    const [leaveReason, setLeaveReason] = useState('');
    const [leaveDetail, setLeaveDetail] = useState('');

    // 颜色值 → memberImageList.type 映射
    // type: 0=默认, 1=绿色, 2=红色, 3=裁判, 4=门将, 5=紫色
    const colorToImageType = (colorValue) => {
        if (colorValue === 'green') return 1;
        if (colorValue === 'red') return 2;
        if (colorValue === '#CCCCFF') return 5;
        return 0; // fallback to default
    };

    // 计算剩余颜色（AB队各占一个颜色，剩下的就是其他球员的颜色）
    const getRemainingColor = () => {
        const allColors = ['green', 'red', '#CCCCFF'];
        const usedColors = [gameDetail?.greenColor, gameDetail?.redColor].filter(Boolean);
        const remaining = allColors.find(c => !usedColors.includes(c));
        return remaining || '#CCCCFF'; // 默认紫色
    };

    // 按type获取成员头像，带fallback链
    const getMemberImageByType = (member, targetType) => {
        if (!member?.memberImageList) return Icon.KEPENG_LOGO;
        // 先尝试目标type
        let image = member.memberImageList.find(item => item.type === targetType)?.image;
        // fallback到默认头像
        if (!image) image = member.memberImageList.find(item => item.type === 0)?.image;
        return image ? (image + Icon.ImageFooter) : Icon.KEPENG_LOGO;
    };

    const hasBothCaptains = !!(gameDetail?.greenCaptainId && gameDetail?.redCaptainId);

    const mainImage = (member, gameType, gameRole) => {
        // 当两个队长都报名了之后，根据角色显示不同队服头像
        if (hasBothCaptains) {
            // 门将 → 门将头像 (type 4)
            if (gameType === 0 && gameRole === 1) {
                return getMemberImageByType(member, 4);
            }
            // 裁判（主裁=gameType 1，边裁=gameType 2）→ 裁判头像 (type 3)
            if (gameType === 1 || gameType === 2) {
                return getMemberImageByType(member, 3);
            }
            // 所有球员（包括队长）→ 剩余颜色的头像
            if (gameType === 0) {
                const remainingColor = getRemainingColor();
                return getMemberImageByType(member, colorToImageType(remainingColor));
            }
        }

        // 没有两个队长时 / 其他情况 → 默认头像 (type 0)
        const image = member?.memberImageList
            ?.find(item => item.type === 0)
            ?.image;
        return image ? (image + Icon.ImageFooter) : Icon.KEPENG_LOGO;
    }

    const getFireDetailInfo = useCallback(() => {

        const showMembers = memberList
            ?.filter((item) =>
                null !== item.gameType && item.gameType <= 7
            )
            ?.map((item) => item.id)
            ?.join(',');

        if (!showMembers) {
            setDisplayList([]);
            return;
        }


        Toast.show({ icon: 'loading', content: '加载中...' });

        axios
            .get(API_ROUTES.game_member_fail_info, {
                params: { memberId: showMembers }
            })
            .then((res) => {
                const data = res.data.data || {};
                setDisplayList(data);
            })
            .catch(() => {
                Toast.show({
                    icon: 'fail',
                    content: '查询失败，请联系管理员'
                });
                setDisplayList([]);
            })
            .finally(() => Toast.clear());
    }, [memberList]);

    useEffect(() => {
        if (memberList && memberList.length > 0) {
            getFireDetailInfo();
        }
    }, [getFireDetailInfo, memberList]);

    const getTypeInfo = (type) => {
        switch (type) {
            case 1:
                return "门将";
            case 2:
                return "边后卫";
            case 3:
                return "中后卫";
            case 4:
                return "后腰";
            case 5:
                return "边前卫";
            case 6:
                return "前腰";
            case 7:
                return "前锋";
            case 8:
                return "主裁";
            case 9:
                return "边裁";
            case 10:
                return "VAR";
            case 11:
                return "观众";
            case 12:
                return "待选队队员"
            default:
                return "临时";
        }
    }

    const getcolorInfo = (type) => {
        switch (type) {
            case 1:
                return "#165DFF"; // Primary Blue/GK
            case 2:
            case 3:
                return "#10B981"; // Teal/Green for Defense
            case 4:
            case 5:
                return "#3B82F6"; // Electric Blue/Midfield
            case 6:
                return "#F59E0B"; // Orange/Forward-Mid
            case 7:
                return "#EF4444"; // Crimson/Attack
            case 8:
            case 9:
            case 10:
                return "#A855F7"; // Purple for Referees
            case 11:
            case 12:
            case 13:
                return "#4E5969"; // Slate for Others
            default:
                return "#86909C";
        }
    }


    const totalPlayerCount = memberList?.filter(item => item.gameType === 0).length || 0;
    // 空分组不渲染标题和内容，避免报名页出现无意义的占位区域。
    const totalRefereeCount = memberList?.filter(item =>
        item.gameType === 1 || item.gameType === 2 || item.gameType === 3 || item.gameType === 4
    ).length || 0;

    // 两个位置编辑入口共用同一组分类选项，保证名称、图标和提交值始终一致。
    const positionOptions = [
        { label: <div className="position-option" data-type="player"><span className="position-option-icon">⚽</span><span className="position-option-copy"><span className="position-option-label">前锋</span><small>场上球员</small></span></div>, value: 7 },
        { label: <div className="position-option" data-type="player"><span className="position-option-icon">🎯</span><span className="position-option-copy"><span className="position-option-label">前腰</span><small>场上球员</small></span></div>, value: 6 },
        { label: <div className="position-option" data-type="player"><span className="position-option-icon">🛡️</span><span className="position-option-copy"><span className="position-option-label">后腰</span><small>场上球员</small></span></div>, value: 4 },
        { label: <div className="position-option" data-type="player"><span className="position-option-icon">⚡</span><span className="position-option-copy"><span className="position-option-label">边前卫</span><small>场上球员</small></span></div>, value: 5 },
        { label: <div className="position-option" data-type="player"><span className="position-option-icon">🏰</span><span className="position-option-copy"><span className="position-option-label">中后卫</span><small>场上球员</small></span></div>, value: 3 },
        { label: <div className="position-option" data-type="player"><span className="position-option-icon">🔰</span><span className="position-option-copy"><span className="position-option-label">边后卫</span><small>场上球员</small></span></div>, value: 2 },
        { label: <div className="position-option" data-type="player"><span className="position-option-icon">🧤</span><span className="position-option-copy"><span className="position-option-label">门将</span><small>场上球员</small></span></div>, value: 1 },
        { label: <div className="position-option" data-type="official"><span className="position-option-icon">🎖️</span><span className="position-option-copy"><span className="position-option-label">主裁</span><small>裁判组</small></span></div>, value: 8 },
        { label: <div className="position-option" data-type="official"><span className="position-option-icon">🚩</span><span className="position-option-copy"><span className="position-option-label">边裁</span><small>裁判组</small></span></div>, value: 9 },
        { label: <div className="position-option" data-type="official"><span className="position-option-icon">📹</span><span className="position-option-copy"><span className="position-option-label">VAR</span><small>裁判组</small></span></div>, value: 10 },
        { label: <div className="position-option" data-type="other"><span className="position-option-icon">👀</span><span className="position-option-copy"><span className="position-option-label">观众</span><small>其他身份</small></span></div>, value: 11 },
        { label: <div className="position-option" data-type="danger"><span className="position-option-icon">❌</span><span className="position-option-copy"><span className="position-option-label">取消报名</span><small>其他身份</small></span></div>, value: 12 },
        { label: <div className="position-option" data-type="leave"><span className="position-option-icon">🏖️</span><span className="position-option-copy"><span className="position-option-label">请假</span><small>其他身份</small></span></div>, value: 13 }
    ];

    // 上场人员与裁判共用同一个底部编辑入口，并预选其当前场上职能。
    const openPositionEditor = user => {
        const officialPosition = { 1: 8, 2: 9, 3: 10, 4: 11 }[user.gameType];
        setSelectedPosition(officialPosition || user.gameRole || null);
        setPositionStage('position');
        setLeaveReason('');
        setLeaveDetail('');
        setEditingUser(user);
    };

    const selectPosition = position => {
        setSelectedPosition(position);
        if (position === 13) setPositionStage('leave');
    };

    const savePosition = async () => {
        if (!editingUser || selectedPosition == null) {
            Toast.show({ icon: 'fail', content: '请选择队员位置' });
            return;
        }
        if (selectedPosition === 13 && !leaveReason && !leaveDetail.trim()) {
            Toast.show({ icon: 'fail', content: '请选择或填写请假原因' });
            return;
        }
        setPositionSaving(true);
        try {
            // 请假走队员报名接口保存原因；其他位置沿用原修改位置接口。
            let response;
            if (selectedPosition === 13) {
                response = await axios.post(API_ROUTES.game_join, {
                    gameId: gameDetail.id,
                    memberId: editingUser.id,
                    gameType: 5,
                    remark: [leaveReason, leaveDetail.trim()].filter(Boolean).join('：'),
                });
            } else {
                const formData = new FormData();
                formData.append('memberId', editingUser.id);
                formData.append('position', selectedPosition);
                formData.append('gameId', gameDetail.id);
                response = await axios.post(API_ROUTES.game_update_allow, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            }
            if (response.data.code !== 200) {
                Toast.show({ icon: 'fail', content: response.data.msg || '修改失败' });
                return;
            }
            setEditingUser(null);
            Toast.show({ icon: 'success', content: '修改成功!' });
            runFunction();
        } catch (error) {
            Toast.show({ icon: 'fail', content: '修改失败，请重试' });
        } finally {
            setPositionSaving(false);
        }
    };

    const parseList = (paramList, type) => {

        const typeInfo = getTypeInfo(type)
        const colorInfo = getcolorInfo(type)

        const listInfo = (user) => (
            <div className={`premium-player-card`}>
                {/* 1. Overflowing Badges (Absolute Positioned relative to Card) */}
                {/* Birthday - Top Left */}
                {user.birthdayInfo && display && (
                    <div className="badge-overflow-birthday">
                        <span>🎂</span>
                    </div>
                )}
                {/* 100th Game - Top Right */}
                {user.oneHundred && display && (
                    <div className="badge-overflow-100">
                        <span>🏆</span>{user.oneHundred}
                    </div>
                )}

                {/* 不败火焰 — 卡片上方 */}
                {(type < 8 || type === 12) && (
                    <div className="card-fire-header">
                        <GetSinglePersonFire
                            records={displayList[user.id]}
                            count={3}
                            trendType="unbeaten"
                        />
                    </div>
                )}

                {/* 2. Avatar with Corner Rank Badge */}
                <div className="premium-avatar-box">
                    <img
                        src={mainImage(user, user.gameType, user.gameRole)}
                        alt={user.name}
                        className="premium-avatar"
                    />
                    <div className={`min-rank-badge ${user.registrationOrder === 1 ? 'rank-gold' :
                        user.registrationOrder === 2 ? 'rank-silver' :
                            user.registrationOrder === 3 ? 'rank-bronze' :
                                user.registrationOrder === totalPlayerCount ? 'rank-last' : 'rank-normal'
                        }`}>
                        {[1, 2, 3].includes(user.registrationOrder) && (
                            <span className="rank-medal-icon">
                                {user.registrationOrder === 1 ? '🥇' : user.registrationOrder === 2 ? '🥈' : '🥉'}
                            </span>
                        )}
                        <span>{user.registrationOrder}</span>
                    </div>
                </div>

                {/* 3. Main Content (Side-by-Side: Name Top, Position Bottom) */}
                <div className="premium-content">
                    <div className="premium-name">{user.name}</div>
                    <div
                        className="premium-position-tag"
                        style={{ color: colorInfo, borderColor: `${colorInfo}40`, background: `${colorInfo}10` }}
                    >
                        {typeInfo}
                    </div>
                </div>

                {/* 4. 不胜火焰 — 卡片下方（原位置） */}
                {(type < 8 || type === 12) && (
                    <div className="card-fire-footer">
                        <GetSinglePersonFire
                            records={displayList[user.id]}
                            count={3}
                            trendType="winless"
                        />
                    </div>
                )}
            </div>
        )

        return (
            <div className="player-group">
                {paramList.map((user, index) => (
                    <div
                        key={index}
                        onClick={() => {
                            if (canManageRoster) {
                                openPositionEditor(user);
                            } else {
                                navigate(`/members/${user.id}`)
                            }
                        }}
                    >
                        {listInfo(user)}
                    </div>
                ))}
            </div>
        )
    }

    const forwardList = memberList?.filter(item => item.gameType === 0 && item.gameRole === 7);
    const mindfielderList = memberList?.filter(item => item.gameType === 0 && item.gameRole === 6);
    const midifielList = memberList?.filter(item => item.gameType === 0 && item.gameRole === 5);
    const wingerList = memberList?.filter(item => item.gameType === 0 && item.gameRole === 4);
    const centerBackList = memberList?.filter(item => item.gameType === 0 && item.gameRole === 3);
    const fullBackList = memberList?.filter(item => item.gameType === 0 && item.gameRole === 2);
    const gatekeeperList = memberList?.filter(item => item.gameType === 0 && item.gameRole === 1);
    const tempMemberList = memberList?.filter(item => item.gameType === 0 && item.tempMember && !item.gameRole);
    const mainList = memberList?.filter(item => item.gameType === 1);
    const subList = memberList?.filter(item => item.gameType === 2)
    const varList = memberList?.filter(item => item.gameType === 3);
    const visitor = memberList?.filter(item => item.gameType === 4);
    const notChooseList = memberList?.filter(item => item.gameRole === 12 && item.gameType === 0);

    return (
        <div>
            {totalPlayerCount > 0 && <>
                <div className="member-category-title">
                    上场队员 ({totalPlayerCount})
                </div>

                {forwardList?.length > 0 && <div className="position-separator">前锋</div>}
                {forwardList?.length > 0 && parseList(forwardList, 7)}

                {mindfielderList?.length > 0 && <div className="position-separator">前腰</div>}
                {mindfielderList?.length > 0 && parseList(mindfielderList, 6)}

                {midifielList?.length > 0 && <div className="position-separator">边前卫</div>}
                {midifielList?.length > 0 && parseList(midifielList, 5)}

                {wingerList?.length > 0 && <div className="position-separator">后腰</div>}
                {wingerList?.length > 0 && parseList(wingerList, 4)}

                {centerBackList?.length > 0 && <div className="position-separator">中后卫</div>}
                {centerBackList?.length > 0 && parseList(centerBackList, 3)}

                {fullBackList?.length > 0 && <div className="position-separator">边后卫</div>}
                {fullBackList?.length > 0 && parseList(fullBackList, 2)}

                {gatekeeperList?.length > 0 && <div className="position-separator">门将</div>}
                {gatekeeperList?.length > 0 && parseList(gatekeeperList, 1)}

                {tempMemberList?.length > 0 && <div className="position-separator">临时</div>}
                {tempMemberList?.length > 0 && parseList(tempMemberList, 0)}

                {notChooseList?.length > 0 && <div className="position-separator">待定</div>}
                {notChooseList?.length > 0 && parseList(notChooseList, 12)}
            </>}

            {totalRefereeCount > 0 && <>
                <div className="member-header-container">
                    <div className="member-category-title">
                        裁判组 ({totalRefereeCount})
                    </div>
                </div>
                <div className="member-category-content">
                    <div className="player-group">
                    {/* Referee List - Consolidated 2-column grid */}
                    {[...mainList, ...subList, ...varList, ...visitor].map((user, index) => {
                        const typeInfo = getTypeInfo(user.gameType === 1 ? 8 : user.gameType === 2 ? 9 : user.gameType === 3 ? 10 : 11);
                        const colorInfo = getcolorInfo(user.gameType === 1 ? 8 : user.gameType === 2 ? 9 : user.gameType === 3 ? 10 : 11);

                        return (
                            <div
                                key={user.id}
                                className={`premium-player-card`}
                                onClick={() => {
                                    if (canManageRoster) {
                                        openPositionEditor(user);
                                    } else {
                                        navigate(`/members/${user.id}`)
                                    }
                                }}
                            >
                                <div className="premium-avatar-box">
                                    <img src={mainImage(user, user.gameType, user.gameRole)} className="premium-avatar" alt={user.name} />
                                </div>
                                <div className="premium-content">
                                    <div className="premium-name">{user.name}</div>
                                    <div
                                        className="premium-position-tag"
                                        style={{ color: colorInfo, borderColor: `${colorInfo}40`, background: `${colorInfo}10` }}
                                    >
                                        {typeInfo}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    </div>
                </div>
            </>}
            <Popup
                visible={!!editingUser}
                onMaskClick={() => !positionSaving && setEditingUser(null)}
                bodyStyle={{ borderTopLeftRadius: 22, borderTopRightRadius: 22, overflow: 'hidden' }}
                style={{ '--z-index': 1250 }}
            >
                <div className="signup-edit-sheet">
                    <div className="signup-edit-header">
                        <button type="button" onClick={() => positionStage === 'leave' ? setPositionStage('position') : setEditingUser(null)} disabled={positionSaving}>
                            {positionStage === 'leave' ? '返回' : '取消'}
                        </button>
                        <div className="signup-edit-header-copy">
                            <strong>{positionStage === 'leave' ? '请假报备' : '修改报名位置'}</strong>
                            <span>{positionStage === 'leave' ? '选择原因，也可以自行填写' : '选择场上职能或本场身份'}</span>
                        </div>
                        <span className="signup-edit-header-spacer" />
                    </div>
                    <div className="signup-edit-content">
                        {editingUser && <div className="signup-edit-person">
                            <img src={mainImage(editingUser, editingUser.gameType, editingUser.gameRole)} alt={editingUser.name} />
                            <div><strong>{editingUser.name}</strong><span>当前：{editingUser.gameType === 0
                                ? getTypeInfo(editingUser.gameRole)
                                : getTypeInfo(({ 1: 8, 2: 9, 3: 10, 4: 11 })[editingUser.gameType])}</span></div>
                        </div>}
                        {positionStage === 'position' ? [
                            { title: '场上球员', options: positionOptions.slice(0, 7) },
                            { title: '裁判与工作人员', options: positionOptions.slice(7, 10) },
                            { title: '其他状态', options: positionOptions.slice(10) },
                        ].map(group => <div key={group.title}>
                            <div className="signup-edit-section-title">{group.title}</div>
                            <div className="signup-edit-options">
                                {group.options.map(option => <button
                                    key={option.value}
                                    type="button"
                                    className={`signup-edit-option ${selectedPosition === option.value ? 'active' : ''} ${option.value === 12 ? 'danger' : ''}`}
                                    aria-pressed={selectedPosition === option.value}
                                    onClick={() => selectPosition(option.value)}
                                >{option.label}</button>)}
                            </div>
                        </div>) : <>
                            {/* 请假原因与队员报名按钮一致，快捷选项和手动补充可单独或组合提交。 */}
                            <div className="signup-edit-section-title">请假原因</div>
                            <div className="signup-edit-reason-grid">
                                {LEAVE_REASONS.map(reason => <button
                                    key={reason.value}
                                    type="button"
                                    className={`signup-edit-option ${leaveReason === reason.value ? 'active' : ''}`}
                                    aria-pressed={leaveReason === reason.value}
                                    onClick={() => setLeaveReason(reason.value)}
                                >{reason.label}</button>)}
                            </div>
                            <div className="signup-edit-section-title">补充说明</div>
                            <Input className="signup-edit-input" placeholder="手动填写原因（选填）" value={leaveDetail} onChange={setLeaveDetail} />
                        </>}
                    </div>
                    <div className="signup-edit-footer">
                        <button type="button" onClick={() => positionStage === 'leave' ? setPositionStage('position') : setEditingUser(null)} disabled={positionSaving}>
                            {positionStage === 'leave' ? '返回选项' : '取消'}
                        </button>
                        <button type="button" className="primary" onClick={savePosition} disabled={positionSaving}>
                            {positionSaving ? '保存中...' : positionStage === 'leave' ? '确认请假' : '确认修改'}
                        </button>
                    </div>
                </div>
            </Popup>
        </div >
    )

}

export default UserList;
